import React, { useEffect, useState } from 'react'
import NavbarMob from '../components/NavbarMob'
import Navbar from '../components/Navbar'
import { useMediaQuery } from 'react-responsive'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";
import top from '../images/FullImage/top.png'
import down from '../images/FullImage/down.png'
import cart1 from '../images/FullImage/cart.png'
import payment from '../images/FullImage/payment.png'
import line from '../images/Home/line.png'
import product1 from '../images/Home/product2.webp'
import heart from '../images/Home/heart.png'
// import cart from '../images/Home/cart.png'
import FooterMob from '../components/FooterMob'
import Footer from '../components/Footer'
import fit from '../images/FullImage/Fit.png'
import shipping from '../images/FullImage/shipping.png'
import returns from '../images/FullImage/Returns.png'
import Modal from './modalImage'
import axios from 'axios'
import { useStore } from '../useStore'
import LiveViews from './LiveViews'
import animationData from "../lotties/Live.json";
import Lottie from "lottie-react";

// import CryptoJS from "crypto-js";

function FullImage() {
    const [similarProducts, setSimilarProducts] = useState([]);
    const [product, setProduct] = useState([]);
    const [selectedItemName, setSelectedItemName] = useState('');
    const [startIndex, setStartIndex] = useState(0);
    const [productDetails, setProductDetails] = useState([]);
    const [selectedSize, setSelectedSize] = useState(""); // Track selected size
    const [selectedColor, setSelectedColor] = useState("");
    const [loginId, setLoginId] = useState(null);
    const [offerPrices, setOfferPrices] = useState({});

    // console.log(product, 'product');

    const admin = useSelector((state) => state.user.admin);

    const { showDropdown, setShowDropdown } = useStore()


    // Enhanced getUniqueColors function
    const getUniqueColors = (colors) => {
        const seen = new Set();

        return colors.filter(color => {
            if (!color) return false; // Skip undefined/null colors

            const normalizedColor = color.toString().toUpperCase()
            if (!normalizedColor || seen.has(normalizedColor)) return false;

            // Check if an image exists for this color
            const hasImage = images.some(
                img => img.Color && img.Color.toString().toUpperCase() === normalizedColor
            );

            if (!hasImage) return false; // Skip colors without matching image

            seen.add(normalizedColor);
            return true;
        });
    };



    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const isTab = useMediaQuery({ query: '(max-width: 1024px)' });

    const location = useLocation();

    const [id, setId] = useState(location.state?.id || '')
    const [itemName, setItemName] = useState(location.state?.itemName || '')

    // const { id, itemName } = location.state || {};


    function encodeBase64(text) {
        return btoa(text);
    }

    //(id,itemName,'lllllllllll');


    // function decryptText(encryptedText) {
    //     const secretKey = "your-secret-key"; // Same key used for encryption
    //     const bytes = CryptoJS.AES.decrypt(encryptedText, secretKey);
    //     const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    //     return decryptedText;
    // }

    // Decryption (Base64 Decoding)
    function decodeBase64(encodedText) {
        try {
            return atob(encodedText);
        } catch (error) {
            console.error("Decoding Error:", error);
            return "";
        }
    }

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const encodedId = queryParams.get("I");
        const encodedName = queryParams.get("N");

        //(encodedId,'hhhh');


        if (encodedId) {
            const decodedId = decodeBase64(encodedId);
            setId(decodedId);
        }

        if (encodedName) {
            const decodedName = decodeBase64(encodedName);
            setItemName(decodedName);
        }
    }, [location]);

    useEffect(() => {
        // Get userId from localStorage
        const storedLoginId = localStorage.getItem('loginId');
        setLoginId(storedLoginId);
    }, []);

    const LedName = localStorage.getItem('loginName')
    const LedEmail = localStorage.getItem('loginEmail')


    const userId = useSelector((state) => state.user.id);
    //('Logged in User ID:', userId);


    //("id", id);
    //("itemname", itemName);

    const cutitemId = itemName ? itemName.split(' ')[0] : '';

    //("cutitemid", cutitemId);


    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    //(product,'product');

    const [productItems, setProductItems] = useState([]);

    //(productItems,'productItems');

    const [modifiedColors, setModifiedColors] = useState([])

    // console.log(modifiedColors,'modifiedColors');

    useEffect(() => {
        const fetchModfiedColors = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getAllModifiedColors/BLACKBATON_2526`);
                const data = await response.json();
                // console.log(data,'data');

                const modifiedColors = data.reduce((acc, item) => {
                    acc[item.db_color] = {
                        name: item.md_color?.toUpperCase() || '',
                        hex: item.hex || ''
                    };
                    return acc;
                }, {});

                setModifiedColors(modifiedColors);
            } catch (error) {
                console.error('Error fetching color and size data:', error);
            }
        };
        fetchModfiedColors()
    }, [])

    const [images, setImages] = useState([]);
    const [loadingImages, setLoadingImages] = useState('loading');

    // console.log(loadingImages, 'loadingImages');


    useEffect(() => {

        setVisibleImages([])

        if (!id || id === '') {
            setLoadingImages('fail')
            return
        }

        if (modifiedColors.length === 0) return


        const fetchProducts = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getProductById/BLACKBATON_2526?Id=${id}`);
                const data = await response.json();
                if (data.length > 0) {
                    setProduct(data[0]); // Extracting first object from array
                }
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        const fetchProductsItems = async () => {

            try {
                const response = await fetch(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${id}`);
                const data = await response.json();

                if (data.length > 0) {

                    // console.log(data.length,'data.length');

                    setProductItems(data); // Save all product items

                    // Deduplicate based on mapped color
                    const uniqueColors = data.reduce((acc, item) => {
                        const rawColor = item.Color?.toUpperCase();
                        const mappedColor = modifiedColors[rawColor]?.name;

                        if (!acc.seen.has(mappedColor)) {
                            acc.seen.add(mappedColor);
                            acc.result.push(item);
                        }

                        return acc;
                    }, { seen: new Set(), result: [] }).result;

                    const imageChecks = await Promise.allSettled(
                        uniqueColors.map(async (item) => {
                            const code = `${item.ItemId}_${modifiedColors[item.Color]?.name}`;
                            const imageUrl = `${apiLocalUrl}/uploads/${code}.webp?v=${Date.now()}`;

                            try {
                                const response = await fetch(imageUrl, { method: "HEAD" });
                                if (response.ok) return { ...item, imageUrl };
                            } catch { }
                            return null;
                        })
                    );

                    const imagesFound = imageChecks
                        .filter(res => res.status === "fulfilled" && res.value)
                        .map(res => res.value);



                    if (imagesFound.length > 0) {
                        setImages(imagesFound);
                        setLoadingImages(false)
                    } else {
                        // console.log(imagesFound.length, 'len');

                        setLoadingImages('fail')
                    }
                }
            } catch (error) {

                console.error('Error fetching product items:', error);
                setLoadingImages('error')
            }
        };


        fetchProducts();

        fetchProductsItems();


    }, [apiBaseUrl, id, itemName, modifiedColors]);

    const [mainImage, setMainImage] = useState(null);

    // useEffect(() => {
    //     if (product?.ID) {
    //         // setMainImage(`${apiLocalUrl}/uploads/${product.UniqueCode}.webp?v=${Date.now()}`); 
    //         // const matchingUniquecode = productItems.find(
    //         //     item => item.Color === selectedColor && item.Size === selectedSize
    //         // );

    //         // if (matchingUniquecode) {
    //         //     const code = `${matchingUniquecode.ItemId}_${modifiedColors[matchingUniquecode.Color]?.name}`
    //         //     setMainImage(`${apiLocalUrl}/uploads/${code}.webp?v=${Date.now()}`);
    //         // }

    //         setMainImage(`${apiLocalUrl}/uploads/${product.displayFirst}?v=${Date.now()}`);
    //     }
    // }, [product]);





    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getProductByFilter/BLACKBATON_2526?filter=${encodeURIComponent(cutitemId)}`);
                const data = await response.json();
                setSimilarProducts(data);

                if (data.length > 0) {
                    setSelectedItemName(data[0].ItemName); // Set the selected item name from the first product
                }
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        fetchProducts();
    }, [apiBaseUrl, cutitemId]);


    const uniqueSizes = [...new Set(productDetails.map((category) => category.Size))];

    // console.log(uniqueSizes, 'uniqueSizes');



    useEffect(() => {
        if (product?.ID) {

            if (product?.displayFirst) {
                // Set main image
                setMainImage(`${apiLocalUrl}/uploads/${product.displayFirst}?v=${Date.now()}`);

                // ✅ Extract itemID and colorName from "56_BLUE.webp"
                const displayWithoutExt = product.displayFirst.replace('.webp', '');
                const [itemID, colorName] = displayWithoutExt.split('_');

                setSelectedColor(colorName); // ✅ Set extracted color

                // Fetch product details
                fetch(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${encodeURIComponent(product.ID)}`)
                    .then(response => response.json())
                    .then(data => {

                        const filteredData = data.filter(item => item.Color && item.Color.trim() !== '');
                        setProductDetails(filteredData);

                        // ✅ Filter sizes that match the extracted color
                        const sizesForColor = data
                            .filter(detail => detail.Color === colorName)
                            .map(detail => detail.Size);

                        // ✅ Set the first matching size
                        if (sizesForColor.length > 0) {
                            setSelectedSize(sizesForColor[0]);
                        }
                    })
                    .catch(error => console.error("Error fetching product details:", error));
            } else {


                setMainImage(`${apiLocalUrl}/uploads/${product.ID}_${images[0]?.Color}.webp?v=${Date.now()}`);
                fetch(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${encodeURIComponent(product.ID)}`)
                    .then(response => response.json())
                    .then(data => {

                        const filteredData = data.filter(item => item.Color && item.Color.trim() !== '');
                        setProductDetails(filteredData);

                        const uniqueSizes = [...new Set(data.map((category) => category.Size))];

                        // handleSizeSelection(uniqueSizes[0])
                        setSelectedSize(uniqueSizes[0]);

                        const colorsForSelectedSize = data
                            .filter((detail) => detail.Size === uniqueSizes[0])
                            .map((detail) => detail.Color);

                        setSelectedColor(colorsForSelectedSize[0]);
                    })
                    .catch(error => console.error("Error fetching product details:", error));
            }

        }
    }, [apiBaseUrl, product.ID, images, product.displayFirst]);


    //(startIndex, 'sss');



    const handleSizeSelection = async (size) => {

        setSelectedSize(size);

        setStartIndex(0)

        const filteredBySize = productItems.filter(item => item.Size === size);

        // //(filteredBySize,'filteredBySize');


        // const generatedImages = filteredBySize.map((item) => {
        //     const code = `${item.ItemId}_${item.Color}`
        //     return {
        //         image: `${apiLocalUrl}/uploads/${code}.webp?v=${Date.now()}`,
        //         size: item.Size,
        //         color: item.Color
        //     };
        // });


        // const slicedImages = generatedImages.slice(startIndex, startIndex + imagesPerPage).map((imgObj, i) => ({
        //     image: imgObj.image || '',
        //     size: generatedImages[startIndex + i]?.size,
        //     color: generatedImages[startIndex + i]?.color
        // }));

        // //(slicedImages,'slicedImages');





        // Find available colors for the selected size
        const colorsForSelectedSize = productDetails
            .filter((detail) => detail.Size === size)
            .map((detail) => detail.Color);

        // If there's only one color, auto-select it
        if (colorsForSelectedSize.length === 1) {
            setSelectedColor(colorsForSelectedSize[0]);
        } else {
            // setSelectedColor(colorsForSelectedSize[0]); // Reset selected color if there are multiple options
            const matchingUniquecode = productItems.find(
                item => item.Color === colorsForSelectedSize[0] && item.Size === size
            );


            if (matchingUniquecode) {
                const code = `${matchingUniquecode.ItemId}_${modifiedColors[matchingUniquecode.Color]?.name}`

                const imageUrl = `${apiLocalUrl}/uploads/${code}.webp`;

                try {
                    const res = await fetch(imageUrl, { method: "HEAD" });
                    if (res.ok) {
                        setMainImage(`${apiLocalUrl}/uploads/${code}.webp?v=${Date.now()}`);
                        setSelectedColor(colorsForSelectedSize[0]);
                    } else {
                        setMainImage(`${apiLocalUrl}/uploads/${product.displayFirst}?v=${Date.now()}`);
                        setSelectedColor('')
                    }

                } catch {

                    setMainImage(`${apiLocalUrl}/uploads/${product.displayFirst}?v=${Date.now()}`);
                }
            }


        }
    };

    const sizesAllocated = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];

    // Extract unique sizes

    // console.log(productItems, 'productItems');



    // Get available colors for the selected size
    const availableColors =
        product.NoSize !== 1
            ? productDetails
                .filter((category) => category.Size === selectedSize)
                .map((category) => category.Color)
            : productDetails.map((category) => category.Color);



    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const home = () => {
        navigate('/')
    }

    const fullimage = (id, itemName) => {
        setId(id)
        setItemName(itemName)
        // navigate('/fullimage', { state: { id, itemName } });
        navigate(`/fullimage?I=${encodeBase64(String(id))}&N=${encodeBase64(itemName)}`);
        window.scrollTo(0, 0); // Scroll to the top after navigation
    };

    const handleAddToCart = async (event) => {
        event.stopPropagation();

        if (!loginId) {
            alert('Please login to continue.');
            navigate('/login');
            return;
        }

        let selectedProductDetail

        if (product.NoSize !== 1) {
            //  Product has sizes — require both
            if (!selectedSize || !selectedColor) {
                alert('Please select a size and color.');
                return;
            }

            // Find matching size + color
            selectedProductDetail = productDetails.find(
                (detail) =>
                    detail.Size === selectedSize &&
                    detail.Color === selectedColor
            );

            if (!selectedProductDetail) {
                alert('Please select a valid size and color.');
                return;
            }


        } else {
            //  No-size product — only color is needed
            if (!selectedColor) {
                alert('Please select a color.');
                return;
            }

            // Find matching color only
            selectedProductDetail = productDetails.find(
                (detail) => detail.Color === selectedColor
            );

            if (!selectedProductDetail) {
                alert('Please select a valid color.');
                return;
            }

        }

        const uniqueCode = selectedProductDetail.Uniquecode;

        // Get offer price if available
        const offerPrice = offerPrices[product.ID];
        const itemPrice = offerPrice !== undefined ? offerPrice : product.MRP;

        // Prepare the data to be sent to the API
        const cartData = [{
            itemId: product.ID,
            uniqueCode: uniqueCode,
            itemName: product.ItemName,
            itemPrice: itemPrice,
            quantity: 1,
            ledname: LedName,
            ledcode: loginId,
            ledemail: LedEmail,
        }];

        try {
            const response = await fetch(`${apiBaseUrl}/cart/add/BLACKBATON_2526`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(cartData),
            });

            if (!response.ok) {
                throw new Error('Failed to add item to cart');
            }

            const result = await response.json();

            if (result.success) {
                alert('Item added to cart successfully!');
            } else {
                alert('Failed to add item to cart. Please try again.');
            }
        } catch (error) {
            console.error('Error adding item to cart:', error);
            alert('An error occurred while adding the item to the cart. Please try again.');
        }
    }; const imagesPerPage = 3;

    // //(productItems,'prooo');

    // Show only 3 images at a time
    // const [visibleImages,setVisibleImages] = useState(images.slice(startIndex, startIndex + imagesPerPage));

    const [visibleImages, setVisibleImages] = useState([]);

    // console.log(visibleImages, 'visibleImages');


    useEffect(() => {
        if (productItems.length > 0) {
            //(productItems, 'ppppppppppp');

            // Filter for unique colors
            const uniqueColors = productItems.reduce((acc, item) => {
                // Skip null or empty color values
                if (!item.Color || item.Color.trim() === '') return acc;

                // Add only if color not already included
                if (!acc.some(existing => existing.Color === item.Color)) {
                    acc.push(item);
                }

                return acc;
            }, []);


            // console.log(uniqueColors, 'uniqueColors');

            // Generate image URLs for unique colors
            const generatedImages = images.map((item) => {
                const code = `${item.ItemId}_${modifiedColors[item.Color]?.name}`;
                return {
                    image: `${apiLocalUrl}/uploads/${code}.webp?v=${Date.now()}`,
                    size: item.Size,
                    color: item.Color
                };
            });

            // console.log(generatedImages, 'generatedImages');


            // Slice for pagination
            const slicedImages = generatedImages.slice(startIndex, startIndex + imagesPerPage).map((imgObj, i) => ({
                image: imgObj.image,
                size: uniqueColors[startIndex + i]?.Size,
                color: uniqueColors[startIndex + i]?.Color
            }));

            setVisibleImages(slicedImages);
        }
    }, [productItems, startIndex, modifiedColors]);


    // useEffect(() => {
    //     const fetchOfferPrices = async () => {
    //         const prices = {};

    //         // Fetch offer price for the main product
    //         try {
    //             const res = await fetch(`${apiBaseUrl}/getOfferByItemId/${id}`);
    //             if (res.ok) {
    //                 const data = await res.json();
    //                 prices[id] = data.OfferPrice;
    //             }
    //         } catch (err) {
    //             console.error(`Error fetching offer for product ${id}`, err);
    //         }

    //         // Fetch offer prices for similar products
    //         for (const product of similarProducts) {
    //             try {
    //                 const res = await fetch(`${apiBaseUrl}/getOfferByItemId/${product.ID}`);
    //                 if (res.ok) {
    //                     const data = await res.json();
    //                     prices[product.ID] = data.OfferPrice;
    //                 }
    //             } catch (err) {
    //                 console.error(`Error fetching offer for product ${product.ID}`, err);
    //             }
    //         }
    //         setOfferPrices(prices);
    //     };

    //     if (id || similarProducts.length > 0) {
    //         fetchOfferPrices();
    //     }
    // }, [id, similarProducts]); // Run when id or similarProducts changes

    // Handlers for navigation
    const handleNext = () => {

        if (startIndex + imagesPerPage < images.length) {

            setStartIndex(startIndex + 1);
        }
    };

    const handlePrev = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - 1);
        }
    };

    const [modalImage, setModalImage] = useState(false)

    useEffect(() => {
        if (modalImage) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        // Clean up in case component unmounts
        return () => {
            document.body.style.overflow = 'auto';
        };

    }, [modalImage]);

    const [respectedSizeArray, setRespectedSizeArray] = useState([])


    const handleRespectedItemInSize = async (item) => {
        // console.log(item,',mmmmmmmmmmm');


        const color = item.color.toString().toUpperCase()
        const md_color = modifiedColors[color]?.name

        // console.log(color,md_color,productItems,'ddd');


        const respectedSizedItems = productItems.filter(item => {
            const itemColor = item.Color?.toUpperCase();
            const itemMdColor = modifiedColors[itemColor]?.name || itemColor; // Map or fallback to original
            return itemMdColor === md_color;
        });

        //   console.log(respectedSizedItems,'respectedSizedItems');


        const sizesArray = respectedSizedItems.map((item) => item.Size);
        setRespectedSizeArray(sizesArray)
    }

    const [distinctColors, setDistinctColors] = useState({});
    const [visibleProducts, setVisibleProducts] = useState([]);
    const [animationTrigger, setAnimationTrigger] = useState(false);


    // Animation effect for staggered product appearance
    useEffect(() => {
        setVisibleProducts([]); // Reset visible products when filteredProducts changes
        setAnimationTrigger(prev => !prev); // Trigger animation

        if (similarProducts.length > 0) {
            // Add products one by one with delay
            similarProducts.forEach((product, index) => {
                setTimeout(() => {
                    setVisibleProducts(prev => [...prev, product.ID]);
                }, index * 100); // 100ms delay between each product
            });
        }
    }, [similarProducts]);

    // Function to fetch colors
    const randomColorInPro = async (itemId) => {
        try {
            const response = await axios.get(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${itemId}`);
            if (response.status === 200) {
                const data = response.data;
                const distinctColors = [...new Set(
                    data.filter(item => item.ItemId === itemId).map(item => item.Color)
                )];
                return distinctColors[0];
            }
        } catch (error) {
            console.error('Error:', error);
            return [];
        }
    };

    // Fetch colors for each product
    useEffect(() => {
        const fetchColors = async () => {
            const colorsMap = {};
            for (const product of similarProducts) {
                const distinctColors = await randomColorInPro(product.ID);
                colorsMap[product.ID] = distinctColors;
            }
            setDistinctColors(colorsMap);
        };

        if (similarProducts.length > 0) {
            fetchColors();
        }
    }, [similarProducts]);

    const [availability, setAvailability] = useState({});

    useEffect(() => {
        const checkImages = async () => {
            const results = {};

            for (const product of similarProducts) {
                const color = distinctColors[product.ID] || [];

                let code = product.displayFirst

                if (!product.displayFirst) {
                    code = `${product.ID}_${color}.webp`;
                }

                const imageUrl = `${apiLocalUrl}/uploads/${code}`;

                try {
                    const res = await fetch(imageUrl, { method: "HEAD" });
                    if (res.ok) {
                        results[product.ID] = res.ok;
                    } else {
                        results[product.ID] = false;
                    }

                } catch {

                    results[product.ID] = false;
                }
            }

            setAvailability(results);
        };

        if (Object.keys(distinctColors).length > 0) {
            checkImages();
        }
    }, [similarProducts, distinctColors]);

    const isProductVisible = (productId) => {
        return visibleProducts.includes(productId);
    };

    if (loadingImages === 'loading') {
        return (
            <div className='min-h-screen flex flex-col relative' onClick={() => setShowDropdown(false)}>
                {isMobile ? <NavbarMob /> : <Navbar />}

                <div className='w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[120px] pb-12'>
                    <div className='flex flex-row gap-2 items-center'>
                        <span className='lg:text-base text-xs font-[500] font-montserrat text-[#828282] cursor-pointer' onClick={home}>Home</span>
                        <span className='text-[#828282]'>{">"}</span>
                        <span className='lg:text-base text-xs font-[400] font-montserrat text-[#3C4242]'>{itemName}</span>
                    </div>
                </div>

                <div className='w-full flex lg:flex-row flex-col justify-center items-center font-semibold text-md md:text-xl p-5 md:p-10'>
                    <span className="inline-block w-5 h-5 border-2 border-gray-300 border-t-black rounded-full animate-spin"></span>

                </div>

                {isTab ? <FooterMob /> : <Footer />}
            </div>
        )
    }

    if (loadingImages === 'fail') {
        return (
            <div className='min-h-screen flex flex-col relative' onClick={() => setShowDropdown(false)}>
                {isMobile ? <NavbarMob /> : <Navbar />}

                <div className='w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[120px] pb-12'>
                    <div className='flex flex-row gap-2 items-center'>
                        <span className='lg:text-base text-xs font-[500] font-montserrat text-[#828282] cursor-pointer' onClick={home}>Home</span>
                        <span className='text-[#828282]'>{">"}</span>
                        <span className='lg:text-base text-xs font-[400] font-montserrat text-[#3C4242]'>{itemName}</span>
                    </div>
                </div>

                <div className='w-full flex lg:flex-row flex-col justify-center items-center font-semibold text-md md:text-xl p-5 md:p-10'>
                    <span>Product is not available!</span>
                </div>

                {isTab ? <FooterMob /> : <Footer />}
            </div>
        )
    }

    if (loadingImages === 'error') {
        return (
            <div className='min-h-screen flex flex-col relative' onClick={() => setShowDropdown(false)}>
                {isMobile ? <NavbarMob /> : <Navbar />}

                <div className='w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[120px] pb-12'>
                    <div className='flex flex-row gap-2 items-center'>
                        <span className='lg:text-base text-xs font-[500] font-montserrat text-[#828282] cursor-pointer' onClick={home}>Home</span>
                        <span className='text-[#828282]'>{">"}</span>
                        <span className='lg:text-base text-xs font-[400] font-montserrat text-[#3C4242]'>{itemName}</span>
                    </div>
                </div>

                <div className='w-full flex lg:flex-row flex-col justify-center items-center font-semibold text-md md:text-xl p-5 md:p-10'>
                    <span className='text-red-500'>Error occured</span>
                </div>

                {isTab ? <FooterMob /> : <Footer />}
            </div>
        )
    }

    return (
        <div className='min-h-screen flex flex-col relative' onClick={() => setShowDropdown(false)}>
            {isMobile ? <NavbarMob /> : <Navbar />}

            <div className='w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[120px] pb-12'>
                <div className='flex flex-row gap-2 items-center'>
                    <div className='w-full flex flex-row gap-2'>
                        <span className='lg:text-base text-xs font-[500] font-montserrat text-[#828282] cursor-pointer' onClick={home}>Home</span>
                        <span className='text-[#828282]'>{">"}</span>
                        <span className='lg:text-base text-xs font-[400] font-montserrat text-[#3C4242]'>{itemName}</span>
                    </div>


                    <div className="w-max h-max flex flex-row justify-center items-center border rounded-md">
                        <div className="px-2">
                            <LiveViews pageId={itemName} />
                        </div>

                        {admin === '1' && (
                            <div className="w-7 border-l">
                                <Lottie animationData={animationData} loop={true} />
                            </div>
                        )}
                    </div>

                </div>

                <div className='w-full flex lg:flex-row flex-col lg:h-[589px]  h-auto lg:gap-0 gap-8'>
                    <div className='flex lg:flex-row flex-col gap-4 lg:w-[50%] w-full h-full'>
                        <div className='w-[25%] h-full lg:flex hidden flex-col justify-center items-center gap-6'>
                            {visibleImages.map((src, index) => {
                                const isSelected = mainImage === src.image;
                                return (
                                    <div key={index} className={`w-[70%] h-[100px] ${isSelected ? 'border-2 border-[#ccc]' : 'border'} rounded-[10px] bg-[#EEEEEE] flex justify-center items-center cursor-pointer`}
                                        onClick={() => {
                                            setMainImage(src.image)
                                            setSelectedSize(src.size);
                                            const normalizedColor = src.color.toString().toUpperCase();

                                            setSelectedColor(normalizedColor)

                                            handleRespectedItemInSize(src)
                                        }} // Update the main image when clicked
                                    >
                                        <img
                                            src={src.image}
                                            alt={`sideimg${index + 1}`}
                                            className="w-full h-full rounded-[10px]"
                                            loading="lazy"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = product1;
                                            }}
                                        />
                                    </div>
                                )
                            })}
                            <div className='flex flex-col gap-2'>
                                <div
                                    className={`w-[35px] h-[35px] rounded-full flex justify-center items-center border-2 border-black cursor-pointer ${startIndex > 0 ? 'bg-black' : 'bg-white'
                                        }`} onClick={handlePrev}
                                    disabled={startIndex === 0}
                                >
                                    <img src={top} alt="top" />
                                </div>
                                <div
                                    className={`w-[35px] h-[35px] rounded-full flex justify-center items-center border-2 border-black cursor-pointer ${startIndex + imagesPerPage >= images.length ? 'bg-white' : 'bg-black'
                                        }`}
                                    onClick={handleNext}
                                    disabled={startIndex + imagesPerPage >= images.length}
                                >
                                    <img src={down} alt="down" />
                                </div>
                            </div>
                        </div>
                        <div className='lg:w-[75%] w-full h-full flex justify-center items-center' onClick={() => setModalImage(true)}>
                            <img
                                src={mainImage}
                                alt="mainimage"
                                loading="lazy"
                                className='w-max max-w-full h-full max-h-full'
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = product1;
                                }}
                            />
                        </div>
                        <div className='w-full h-full flex lg:hidden  flex-row justify-center items-center gap-3'>
                            {visibleImages.map((src, index) => (
                                <div key={index} className="w-[70%] h-[100px] rounded-[10px] bg-[#EEEEEE] flex justify-center items-center cursor-pointer"
                                    onClick={() => {
                                        setMainImage(src.image)
                                        setSelectedSize(src.size);
                                        const normalizedColor = src.color.toString().toUpperCase();
                                        setSelectedColor(normalizedColor)

                                        handleRespectedItemInSize(src)
                                    }} // Update the main image when clicked
                                >
                                    <img
                                        src={src.image}
                                        alt={`sideimg${index + 1}`}
                                        className="w-full h-full"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = product1;
                                        }}
                                    />
                                </div>
                            ))}
                            <div className='flex flex-col gap-2'>
                                <div
                                    className={`w-[35px] h-[35px] rounded-full flex justify-center items-center border-2 border-black cursor-pointer ${startIndex > 0 ? 'bg-black' : 'bg-white'
                                        }`} onClick={handlePrev}
                                    disabled={startIndex === 0}
                                >
                                    <img src={top} alt="top" />
                                </div>
                                <div
                                    className={`w-[35px] h-[35px] rounded-full flex justify-center items-center border-2 border-black cursor-pointer ${startIndex + imagesPerPage >= images.length ? 'bg-white' : 'bg-black'
                                        }`}
                                    onClick={handleNext}
                                    disabled={startIndex + imagesPerPage >= images.length}
                                >
                                    <img src={down} alt="down" />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='flex flex-col lg:gap-8 gap-5 lg:w-[50%] w-full h-full lg:px-[4%] px-0 '>
                        <span className='lg:text-4xl text-xl font-[600] font-montserrat text-left'>{product.ItemName} <br />
                            {modifiedColors[selectedColor]?.name && (
                                <span className='lg:text-[1.5rem] text-[1rem]'>[{modifiedColors[selectedColor]?.name}]</span>
                            )}
                        </span>

                        <div className='lg:hidden flex flex-row gap-3 items-center'>
                            <span className='font-[400] font-montserrat text-sm'>
                                {offerPrices[product.ID] ? 'Offer Price' : 'MRP'}
                            </span>
                            <span className='font-[600] font-montserrat text-base'>
                                ₹ {offerPrices[product.ID] || product.MRP}
                            </span>
                            {offerPrices[product.ID] && (
                                <span className='line-through text-gray-500 text-sm ml-1'>
                                    ₹{product.MRP}
                                </span>
                            )}
                        </div>

                        {product.NoSize !== 1 && (
                            <div className='flex flex-col gap-3'>
                                <span className='lg:text-lg text-sm font-[500] text-[#3F4646] text-left'>Select Size</span>
                                <div className='flex flex-row gap-5'>
                                    {uniqueSizes
                                        .filter(size => size && size.trim() !== '') // remove null, undefined, or empty strings
                                        .sort((a, b) => sizesAllocated.indexOf(a) - sizesAllocated.indexOf(b))
                                        .map((size) => (
                                            <div className='flex flex-col gap-1' key={size}>
                                                {/* {respectedSizeArray.includes(size.trim()) ? (
                                            <div className="w-full rounded-full bg-[#3C4242] h-1"></div>
                                        ) : respectedSizeArray.length > 0 && (
                                            <div className="w-full rounded-full bg-[#fff] h-1"></div>
                                        )} */}
                                                <div

                                                    onClick={() => {
                                                        if (product.NoSize !== 1) {
                                                            setRespectedSizeArray([])
                                                            handleSizeSelection(size)
                                                            setTimeout(() => handleSizeSelection(size), 50);
                                                        }
                                                    }}
                                                    className={`w-[38px] h-[38px] rounded-[12px] border-2 ${(!respectedSizeArray.includes(size) && respectedSizeArray.length > 0) ? 'bg-[#3C4242] bg-opacity-20' : respectedSizeArray.length > 0 && 'bg-[#fff]'} flex justify-center items-center text-sm font-[500] font-montserrat text-[#3C4242] cursor-pointer 
                                            ${selectedSize === size ? "border-4 border-[#3C4242]" : "border-[#BEBCBD]"}`}
                                                >
                                                    {size}
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        )}

                        <div className='flex flex-col gap-3'>
                            <span className='lg:text-lg text-sm font-[600] text-[black] text-left'>Colours Available</span>

                            <div className='flex flex-row gap-3 flex-wrap'> {/* Changed to flex-wrap for better mobile */}
                                {getUniqueColors(availableColors).map((color) => {
                                    const normalizedColor = color?.toString().toUpperCase();
                                    const colorValue = modifiedColors[normalizedColor]?.hex;

                                    return (
                                        <div
                                            key={normalizedColor}
                                            onClick={() => {
                                                setSelectedColor(normalizedColor);

                                                // 🛡️ Ensure productItems is valid
                                                if (!Array.isArray(productItems) || productItems.length === 0) {
                                                    console.warn("⚠️ productItems not loaded or empty.");
                                                    return;
                                                }

                                                let matchingUniquecode = null;

                                                // 🧩 Find the matching product item
                                                if (product.NoSize === 1) {
                                                    matchingUniquecode = productItems.find(
                                                        (item) => item.Color?.toUpperCase() === normalizedColor
                                                    );
                                                } else {
                                                    setRespectedSizeArray([]);
                                                    matchingUniquecode = productItems.find(
                                                        (item) =>
                                                            item.Color?.toUpperCase() === normalizedColor &&
                                                            item.Size === selectedSize
                                                    );
                                                }

                                                if (!matchingUniquecode) {
                                                    console.warn("⚠️ No matching product found for", normalizedColor);
                                                    return;
                                                }

                                                // 🎨 Get readable color name from modifiedColors
                                                const colorName =
                                                    modifiedColors[matchingUniquecode.Color?.toUpperCase()]?.name || normalizedColor;

                                                // 🧾 Build unique code and update image
                                                const code = `${matchingUniquecode.ItemId}_${colorName}`;
                                                setMainImage(`${apiLocalUrl}/uploads/${code}.webp?v=${Date.now()}`);
                                            }}
                                            className={`
                w-[25px] h-[25px] rounded-full cursor-pointer border border-gray-200
                ${selectedColor === normalizedColor
                                                    ? "ring-2 ring-black ring-offset-1"
                                                    : "hover:border-gray-400"}
            `}
                                            style={{
                                                backgroundColor: colorValue || "#ccc",
                                                borderColor: colorValue === "#FFFFFF" ? "#ccc" : "#ccc",
                                            }}
                                            title={normalizedColor
                                                .split(" ")
                                                .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
                                                .join(" ")}
                                            aria-label={`Color ${normalizedColor}`}
                                        />
                                    );
                                })}

                            </div>
                        </div>

                        <div className='flex flex-row gap-8'>
                            <div className='lg:w-[35%] w-full h-[46px] bg-[black] rounded-[8px] flex flex-row gap-2 items-center justify-center cursor-pointer' onClick={(e) => handleAddToCart(e)}>
                                <img src={cart1} alt="cart" />
                                <span className='lg:text-lg text-base font-[600] font-montserrat text-[white]'>Add to cart</span>
                            </div>
                            <div className='w-[25%] h-[46px] border-2 border-[black] rounded-[8px] lg:flex hidden items-center justify-center'>
                                <span className='text-lg font-[600] font-montserrat'> ₹ {offerPrices[product.ID] || product.MRP}</span>
                            </div>
                        </div>

                        <ul className='border-2 border-[#BEBCBD] mt-3 lg:flex hidden' />

                        <div className='grid grid-cols-2 lg:gap-6 gap-3'>
                            <div className='flex-row lg:gap-4 gap-2 flex items-center'>
                                <div className='w-[45px] h-[45px] rounded-full bg-[#F6F6F6] flex justify-center items-center'>
                                    <img src={payment} alt="payment" />
                                </div>
                                <span className='lg:text-lg text-xs font-[600] font-montserrat text-left'>Secure payment</span>
                            </div>
                            <div className='flex-row lg:gap-4 gap-2 flex items-center'>
                                <div className='w-[45px] h-[45px] rounded-full bg-[#F6F6F6] flex justify-center items-center'>
                                    <img src={fit} alt="payment" />
                                </div>
                                <span className='lg:text-lg text-xs font-[600] font-montserrat text-left'>Size & Fit</span>
                            </div>
                            <div className='flex-row lg:gap-4 gap-2 flex items-center'>
                                <div className='w-[45px] h-[45px] rounded-full bg-[#F6F6F6] flex justify-center items-center'>
                                    <img src={shipping} alt="payment" />
                                </div>
                                <span className='lg:text-lg text-xs font-[600] font-montserrat text-left'>Free shipping</span>
                            </div>
                            <div className='flex-row lg:gap-4 gap-2 flex items-center'>
                                <div className='w-[45px] h-[45px] rounded-full bg-[#F6F6F6] flex justify-center items-center'>
                                    <img src={returns} alt="payment" />
                                </div>
                                <span className='lg:text-lg text-xs font-[600] font-montserrat text-left'>Free Shipping & Returns</span>
                            </div>
                        </div>
                    </div>
                </div>


                <div className='flex flex-col gap-4 w-full'>



                </div>

                {Object.values(availability).every(v => v === true) && (
                    <div className='flex flex-col gap-6 lg:pb-12 pb-6'>
                    <div className='flex flex-row  w-full'>
                        <div className='flex flex-row gap-4  items-center'>
                            <img src={line} alt="line" />
                            <span className='lg:text-xl text-base font-[600] font-montserrat'>Similar Products</span>
                        </div>
                    </div>
                    <div className='grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 w-full  gap-5 '>
                        {similarProducts.map((product, index) => {

                            const isAvailable = availability[product.ID];
                            const isVisible = isProductVisible(product.ID);

                            const color = distinctColors[product.ID] || [];

                            let code = product.displayFirst

                            if (!product.displayFirst) {
                                code = `${product.ID}_${color}.webp`;
                            }


                            // ✅ Skip unavailable images
                            if (isAvailable === false) return null;

                            return (
                                <div key={product.ID}
                                    className={`flex flex-col gap-2 cursor-pointer transition-all duration-500 ease-out transform ${isVisible
                                        ? 'opacity-100 translate-y-0 scale-100'
                                        : 'opacity-0 translate-y-0 scale-95'
                                        }`}
                                    style={{
                                        transitionDelay: isVisible ? `${index * 100}ms` : '0ms'
                                    }}
                                    onClick={() => fullimage(product.ID, product.ItemName)}>
                                    <div className='lg:h-[382px] md:h-[300px] h-[200px] rounded-[12px] bg-[#EEEEEE] flex items-center justify-center relative'>
                                        {isAvailable === undefined && (
                                            <div className="absolute inset-0 flex items-center justify-center">
                                                <div className="w-6 h-6 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
                                            </div>
                                        )}

                                        {isAvailable === true && (
                                            <img
                                                src={`${apiLocalUrl}/uploads/${code}?v=${Date.now()}`}
                                                alt={product.ItemName}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = product1;
                                                }}
                                                className='mix-blend-multiply w-full h-full rounded-[12px] object-cover transition-transform duration-500 hover:scale-105'
                                            />
                                        )}

                                        <div className='absolute top-0 left-0 w-full h-full lg:p-6 p-2 flex justify-end'>
                                            <div className='lg:w-[33px] w-[23px] lg:h-[33px] h-[23px] rounded-full bg-[white] flex justify-center items-center'>
                                                <img src={heart} alt="heart" />
                                            </div>
                                        </div>

                                    </div>
                                    <div className='flex justify-between w-full'>
                                        <div className='flex flex-col gap-1 w-full'>
                                            <span className='lg:text-base text-xs font-[600] font-montserrat text-left'>{product.ItemName}</span>


                                        </div>
                                        <div className='flex flex-col gap-1 items-end'>
                                            <div className='lg:w-[84px] lg:h-[37px] w-[70px] h-[30px] rounded-[8px] bg-[#F6F6F6] text-red-600 flex justify-center items-center text-sm font-[700] font-montserrat'>
                                                ₹{product.MRP}
                                            </div>
                                            {/* <span className="text-sm font-montserrat lg:flex hidden text-nowrap">
                                                Offer Price:
                                                <span className="line-through text-gray-500 ml-1">₹{product.MRP}</span>
                                                <span className="text-red-600 font-bold ml-1">₹{offerPrices[product.ID] || product.MRP}</span>
                                            </span>
                                            <span className="text-sm font-montserrat lg:hidden flex text-nowrap">

                                                <span className="line-through text-gray-500 ml-1">₹{product.MRP}</span>
                                                <span className="text-red-600 font-bold ml-1">₹{offerPrices[product.ID] || product.MRP}</span>
                                            </span> */}
                                        </div>


                                    </div>
                                </div>
                            )
                        })}



                    </div>
                </div>
                )}
            </div>
            {isTab ? <FooterMob /> : <Footer />}

            {modalImage && (
                <div className="fixed top-0 left-0 w-screen h-screen flex justify-center items-center bg-black bg-opacity-50 z-50">
                    <Modal imageUrl={mainImage} onClose={() => setModalImage(false)} />
                </div>
            )}

        </div>
    )
}

export default FullImage